module.exports = __webpack_public_path__ + "static/media/RobotoCondensed-Bold.141d6bca.ttf";